import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import MapContext from "../../../application/Context/MapContext";
export var InfoBar = function () {
    var t = useTranslation(['news']).t;
    var _a = React.useContext(MapContext), companies = _a.companies, projects = _a.projects;
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [" ", companies.length + projects.length, " ", t("éléments")] }) }));
};
